// extracted by mini-css-extract-plugin
export default {"editable-cell__text-input":"EditableLabel_editable-cell__text-input__-SEwS"};